import React, { useEffect, useState } from "react";
import FeaturedCard from "./FeaturedCard";
import axios from "axios";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";

function FeaturedItems({
  foodMenus,
  settings,
  setFoodMenus,
  loader,
  setSubData,
  subData,
}) {
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));
  const customer = JSON.parse(localStorage.getItem("rms-customer"));

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/foodMenus`, {
        params: {
          outletId: outlet?.outlet.id,
          customer_id: customer?.customer?.id,
        },
      })
      .then((res) => {
        setFoodMenus(res.data.foodMenus);
        setSubData(res.data.subscriber_merged_categories_quantity);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [
    customer?.customer?.id,
    customer?.id,
    outlet?.outlet.id,
    setFoodMenus,
    setSubData,
  ]);

  if (isLoading) {
    return (
      <div className="w-full grid place-items-center h-64">
        <img src={loader?.loader_url} className="w-16" alt="loading..." />
      </div>
    );
  }

  return (
    <section className="my-8">
      <div className="max-w-7xl w-[90%] mx-auto">
        <h2 className="text-2xl font-bold text-w-heading">
          {" "}
          {languageHelper("featured items") || "Featured Items"}
        </h2>
        <div className="my-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {foodMenus.map((menu, index) => (
            <FeaturedCard
              key={index}
              menu={menu}
              settings={settings}
              subData={subData.filter(
                (item) => item.category_id === menu.category_id
              )[0]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedItems;
